import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import moment from 'moment';
import queryString from 'query-string';
import { find, maxBy, sortBy } from 'lodash';
import {
  Button, Container, Divider, Form,
  Grid, Header, Image, List,
  Loader, Modal, Statistic, Segment,
  Table
} from 'semantic-ui-react';
import ReactTable from 'react-table';
import feathersConnect from './../../../providers/feathersConnect';
import numeral from 'numeral';

const INITIAL_STATE = {
  loading: false,
  error: null,
  data: null,
  prompt: {
    open: false,
    values: {
      general: false,
      cargos: false,
      vigenciaCargos: false,
      asociados: false,
      asamblea: "ninguna",
      eeconomico: false
    }
  }
};

class ReportePorMatriculaView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;

    this.CooperativaService = this.props.feathers.service('/api/cooperativas');
  }

  createInputHandler (name) {
    
    return (e, input) => {
      if (name == "asamblea") {
        this.setState({
          prompt: {
            ...this.state.prompt,
            values: {
              ...this.state.prompt.values,
              [name]: input.value
            }
          }
        });
        return;
      }
      this.setState({
        prompt: {
          ...this.state.prompt,
          values: {
            ...this.state.prompt.values,
            [name]: !this.state.prompt.values[name]
          }
        }
      });
    };
  }

  togglePrompt () {
    this.setState({
      prompt: {
        ...this.state.prompt,
        open: !this.state.prompt.open
      }
    });
  }

  setPromptData (e) {
    this.setState({
      prompt: {
        ...this.state.prompt,
        open: false
      }
    }, () => window.print());
  }

  findCooperativa () {
    this.setState({
      loading: true,
      error: null,
      data: null
    });

    let query = queryString.parse(this.props.location.search);

    this.CooperativaService.get(query.id, {
      query: {
        report: true
      }
    })
      .then(response => {
        this.setState({
          loading: false,
          data: response
        }, () => {
          this.togglePrompt();
        });
      })
      .catch(error => {
        this.setState({
          loading: false,
          error
        });
      });
  }

  mapEstadoSituacionPatrimonialToTable (estadoSituacionPatrimonial) {
    return [
      {
        concepto: estadoSituacionPatrimonial
      }
    ];
  }

  componentDidMount () {
    this.findCooperativa();
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let {
      loading,
      data,
      error,
      prompt
    } = this.state;
    let lastActa = null;
    let lastEeconomico = null;
    let prevEeconomico = null;

    if (loading) {
      return (
        <Container fluid>
          <Loader active content="Cargando" inline="centered" />
        </Container>
      );
    } else if (data) {
      lastActa = maxBy(data.actasDistribucionCargos, a => a.nroActa);
      lastEeconomico = maxBy(data.eeconomicos, e => parseInt(e.nroEjercicio));
      prevEeconomico = find(data.eeconomicos, e => (parseInt(e.nroEjercicio) === parseInt(lastEeconomico.nroEjercicio) - 1));

      return (
        <Container fluid>
          <Modal closeOnDimmerClick={false} open={prompt.open}>
            <Modal.Header content="Elegir Campos" />
            <Modal.Content>
              <Form>
                <Form.Checkbox label="General" checked={prompt.values.general} onChange={this.createInputHandler('general')} />
                <Form.Group>
                  <Form.Checkbox label="Cargos" checked={prompt.values.cargos} onChange={this.createInputHandler('cargos')} />
                  <Form.Checkbox label="Vigencia" disabled={!prompt.values.cargos} checked={prompt.values.vigenciaCargos} onChange={this.createInputHandler('vigenciaCargos')} />
                </Form.Group>
                <Form.Checkbox label="Asociados" checked={prompt.values.asociados} onChange={this.createInputHandler('asociados')} />
                <Form.Checkbox label="Economico" checked={prompt.values.eeconomico} onChange={this.createInputHandler('eeconomico')} />
                <Form.Select
                label="Asamblea"
              name="asamblea"
              options={[
                { key: "ninguna", text: "Ninguna", value: "ninguna" },
                { key: "all", text: "Todas", value: "todas" },
                ...data.asambleas.map(a => ({key: a.id, text: `Acta Convocatoria ${a.actaConvocatoria} - ${a.fechaAsamblea}`, value: a.id}))
              ]}
              value={prompt.values.asamblea}
              onChange={this.createInputHandler('asamblea')}
            />
                {/* <Form.Checkbox label="Asamblea" checked={prompt.values.asamblea} onChange={this.createInputHandler('asamblea')} /> */}
                
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button primary content="Aceptar" onClick={this.setPromptData.bind(this)} />
            </Modal.Actions>
          </Modal>
          <Image centered style={{ maxHeight: 100 }} src={require('../../../assets/img/logo_dgc.jpg')} />
          <Header
            dividing size="tiny" style={{ margin: 0 }}
            subheader="Peru 1186 - Corrientes - dircoopctes@gmail.com - Tel. 0379-4431360 / 4476041" textAlign="center" />
          <Header style={{ margin: 0 }} as="h4" textAlign="center">Información no certificada por el Estado Provincial</Header>
          <Header as="h2">
            {data.nombre}
            <Header.Subheader>
              M.N. {data.matriculaNacional} M.P. {data.matriculaProvincial}
            </Header.Subheader>
          </Header>
          {
            prompt.values.general && [
            <Segment key={0}>
              <Header as="h3">
                  Datos Generales
              </Header>
              <List divided>
                <List.Item header="Situacion" content={data.situacion} />
                <List.Item header="CUIT" content={data.cuit} />
                <List.Item header="Nro Carpeta" content={data.nroCarpeta} />
                <List.Item header="Protocolo" content={data.protocolo} />
                <List.Item header="Telefono" content={data.telefono} />
                <List.Item header="Contacto" content={data.contacto} />
              </List>
            </Segment>,
            <Segment key={1}>
              <Header as="h3">
                  Fundacion y Cierre
              </Header>
              <List divided>
                <List.Item header="Fundacion" content={moment(data.fechaFundacion).format('DD/MM/YYYY')} />
                <List.Item header="Cierre" content={data.cierreEjercicio} />
              </List>
            </Segment>,
            <Segment key={2}>
              <Header as="h3">
                  Actividad y Sector
              </Header>
              <List divided>
                <List.Item header="Actividad" content={data.actividad} />
                <List.Item header="Sector" content={data.sector.nombre} />
                <List.Item header="Rubro" content={data.sector.rubro.nombre} />
              </List>
            </Segment>,
            <Segment key={3}>
              <Header as="h3">
                  Postal
              </Header>
              <List divided>
                <List.Item header="Localidad" content={data.localidad.nombre} />
                <List.Item header="Dpto" content={data.localidad.departamento.nombre} />
                <List.Item header="Codigo Postal" content={data.codigoPostal} />
                <List.Item header="Domicilio Postal" content={data.domicilioPostal} />
              </List>
            </Segment>
          ]
          }
          {
            prompt.values.cargos &&
            <Segment>
              {
                lastActa ? [
                  <Header as="h3" key={0}>
                    Distribucion de Cargos
                    <Header.Subheader>Nro de Acta {lastActa.nroActa}</Header.Subheader>
                  </Header>,
                  <List divided key={1}>
                    {
                      sortBy(lastActa.cargos, c => c.cargo.orden).map(personaCargo => {
                        let content = `${personaCargo.persona.apellido}, ${personaCargo.persona.nombre}`;

                        if (prompt.values.vigenciaCargos) {
                          let vigencia = moment(personaCargo.vigenteHasta);
                          if (vigencia.isValid()) {
                            content = content.concat(` hasta ${vigencia.format('DD/MM/YYYY')}`);
                          } else {
                            content = content.concat(' (sin vigencia)');
                          }
                        }

                        return (
                          <List.Item
                            key={personaCargo.id}
                            header={personaCargo.cargo.nombre}
                            content={content} />
                        );
                      })
                    }
                  </List>
                ] : <Header as="h3" content="Sin Cargos" />
              }
            </Segment>
          }
          {
            prompt.values.asociados &&
            <Segment>
              {
                data.asociados.length !== 0 ? [
                  <Header as="h3" key={0}>
                    Asociados
                    <Header.Subheader>Cantidad de Asociados {data.asociados.length}</Header.Subheader>
                  </Header>,
                  <List divided key={1}>
                    {
                      data.asociados.map(asociado => (
                        <List.Item
                          key={asociado.id}
                          content={`${asociado.apellido}, ${asociado.nombre} (${asociado.dni})`} />
                      ))
                    }
                  </List>
                ] : <Header as="h3" content="Sin Asociados" />
              }
            </Segment>
          }
          {
            prompt.values.asamblea != "ninguna" &&
              (prompt.values.asamblea == "todas" ? data.asambleas: data.asambleas.filter(a => a.id == prompt.values.asamblea)).map((asamblea, index) => (
                <Segment key={index} className="page-break">
                  {
                    asamblea ? [
                      <Header as="h3" key={0}>
                        Asamblea
                        <Header.Subheader>Acta Convocatoria {asamblea.actaConvocatoria}</Header.Subheader>
                      </Header>,
                      <List divided key={1}>
                        <List.Item header="Acta Distribucion de Cargos" content={asamblea.actaDistribucionCargos} />
                        <List.Item header="Acta Realizacion" content={asamblea.actaRealizacon} />
                        <List.Item header="Fecha Convocatoria" content={moment(asamblea.convocatoria).format('DD/MM/YYYY')} />
                        <List.Item header="Fecha Asamblea" content={moment(asamblea.fechaAsamblea).format('DD/MM/YYYY')} />
                        <List.Item header="Fecha Cierre" content={moment(asamblea.fechaCierreAsamblea).format('DD/MM/YYYY')} />
                      </List>,
                      <Grid key={2}>
                        <Grid.Row columns={2}>
                          <Grid.Column>
                            <Header as="h4">
                            Documentacion Pre-Asamblea
                            </Header>
                            <List>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docConvocatoriaAsamblea ? 'checkmark' : 'remove'}
                                  color={asamblea.docConvocatoriaAsamblea ? 'green' : 'red'} />
                                <List.Content>
                                Convocatoria de asamblea
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docNominaAsociados ? 'checkmark' : 'remove'}
                                  color={asamblea.docNominaAsociados ? 'green' : 'red'} />
                                <List.Content>
                                Nomina de Asociados
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docDDJJFondoEducacionPromocion ? 'checkmark' : 'remove'}
                                  color={asamblea.docDDJJFondoEducacionPromocion ? 'green' : 'red'} />
                                <List.Content>
                                DDJJ del Fondo de Educación y Promoción Cooperativa
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docPreTasaActuacionAdministrativa ? 'checkmark' : 'remove'}
                                  color={asamblea.docPreTasaActuacionAdministrativa ? 'green' : 'red'} />
                                <List.Content>
                                Tasa de Actuación Administrativa
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docCopiaActaReunionConsejoAdministracion ? 'checkmark' : 'remove'}
                                  color={asamblea.docCopiaActaReunionConsejoAdministracion ? 'green' : 'red'} />
                                <List.Content>
                                Copia del acta de Reunión del Consejo de Administración
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docPublicacionBoletinOficial ? 'checkmark' : 'remove'}
                                  color={asamblea.docPublicacionBoletinOficial ? 'green' : 'red'} />
                                <List.Content>
                                Publicación en el Boletín Oficial
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docPlanillaDatosEstadisticos ? 'checkmark' : 'remove'}
                                  color={asamblea.docPlanillaDatosEstadisticos ? 'green' : 'red'} />
                                <List.Content>
                                Planilla Datos Estadísticos
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docEstadosContablesNotasEstadosContablesInformeAuditor ? 'checkmark' : 'remove'}
                                  color={asamblea.docEstadosContablesNotasEstadosContablesInformeAuditor ? 'green' : 'red'} />
                                <List.Content>
                                Estados Contables
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docMemoriaAnual ? 'checkmark' : 'remove'}
                                  color={asamblea.docMemoriaAnual ? 'green' : 'red'} />
                                <List.Content>
                                Memoria anual
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docInformeSindico ? 'checkmark' : 'remove'}
                                  color={asamblea.docInformeSindico ? 'green' : 'red'} />
                                <List.Content>
                                Informe de sindico
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docProyectoDistribucionExcedentes ? 'checkmark' : 'remove'}
                                  color={asamblea.docProyectoDistribucionExcedentes ? 'green' : 'red'} />
                                <List.Content>
                                Proyecto de distribución de excedentes
                                </List.Content>
                              </List.Item>
                            </List>
                          </Grid.Column>
                          <Grid.Column>
                            <Header as="h4">
                            Documentacion Post-Asamblea
                            </Header>
                            <List>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docDatosInformativosConsejerosSindicos ? 'checkmark' : 'remove'}
                                  color={asamblea.docDatosInformativosConsejerosSindicos ? 'green' : 'red'} />
                                <List.Content>
                                Datos Informativos de Consejeros y Síndicos
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docRegistroAsistenciaAsociadosAsamblea ? 'checkmark' : 'remove'}
                                  color={asamblea.docRegistroAsistenciaAsociadosAsamblea ? 'green' : 'red'} />
                                <List.Content>
                                Registro de Asistencia de Asociados a la Asamblea
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docPostTasaActuacionAdministrativa ? 'checkmark' : 'remove'}
                                  color={asamblea.docPostTasaActuacionAdministrativa ? 'green' : 'red'} />
                                <List.Content>
                                Tasa de Actuación Administrativa
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docActaAsamblea ? 'checkmark' : 'remove'}
                                  color={asamblea.docActaAsamblea ? 'green' : 'red'} />
                                <List.Content>
                                Acta de asamblea
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docActaReunionConsejoAdministracion ? 'checkmark' : 'remove'}
                                  color={asamblea.docActaReunionConsejoAdministracion ? 'green' : 'red'} />
                                <List.Content>
                                Acta de Reunión de consejo de administración
                                </List.Content>
                              </List.Item>
                            </List>
                          </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={1}>
                          <Grid.Column>
                            <Header as="h4">
                            Documentacion INAES
                            </Header>
                            <List>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docRecibidaINAES ? 'checkmark' : 'remove'}
                                  color={asamblea.docRecibidaINAES ? 'green' : 'red'} />
                                <List.Content>
                                DOCUMENTACION RECIBIDA PARA INAES
                                </List.Content>
                              </List.Item>
                              <List.Item>
                                <List.Icon
                                  name={asamblea.docEnviadaINAES ? 'checkmark' : 'remove'}
                                  color={asamblea.docEnviadaINAES ? 'green' : 'red'} />
                                <List.Content>
                                DOCUMENTACION ENVIADA A INAES
                                </List.Content>
                              </List.Item>
                            </List>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    ] : <Header as="h3" content="Sin Asambleas" />
                  }
                </Segment>
              ))
          }
          {
            prompt.values.eeconomico &&
            <Segment>
              {
                lastEeconomico ? [
                  <Header as="h3" key={0}>
                    Ultimo Ejercicio Economico
                    <Header.Subheader>
                      Ejercicio Nro {lastEeconomico.nroEjercicio} ({moment(lastEeconomico.fechaInicio).format('DD/MM/YYYY')} - {moment(lastEeconomico.fechaFin).format('DD/MM/YYYY')})
                    </Header.Subheader>
                  </Header>,
                  <Header as="h4" key={1}>
                    Estado de Situacion Patrimonial
                  </Header>,
                  <EstadoSituacionPatrimonial key={2} espatrimonial={lastEeconomico.estadoSituacionPatrimonial} prevEeconomico={prevEeconomico} />,
                  <EstadoEvolucionPatrimonioNeto key={4} eeconomico={lastEeconomico} data={lastEeconomico.estadoEvolucionPatrimonio.matrix} prevEeconomico={prevEeconomico} />,
                  <Header className="page-break" as="h4" key={5}>
                    Estado de Resultados
                  </Header>,
                  <EstadoResultados key={6} eeconomico={lastEeconomico} prevEeconomico={prevEeconomico} estadoResultados={lastEeconomico.estadoResultados} />,
                  <Header className="page-break" as="h4" key={7}>
                    Propuesta de Aplicacion y Distribucion de Excedentes
                  </Header>,
                  <PropuestaAplicacionDistribucionExcedentes
                    key={8} eeconomico={lastEeconomico} prevEeconomico={prevEeconomico} propuestaAplicacionDistribucion={lastEeconomico.propuestaAplicacionDistribucion} />
                ] : <Header as="h3" content="Sin Ejercicio Economico" />
              }
            </Segment>
          }
        </Container>
      );
    } else if (error) {
      return (
        <Container fluid>
          Error
        </Container>
      );
    }

    return (
      <Container fluid>
        Reporte Por Matricula
      </Container>
    );
  }
}

function sumStringsToFloats (...stringValues) {
  return stringValues.reduce((prev, curr) => prev + numeral(curr).value(), 0).toFixed(2);
}

const EstadoSituacionPatrimonial = ({ prevEeconomico, espatrimonial }) => (
  <div>
    <Header as="h5" content="Activo" />
    <Header as="h5" content="Activo Corriente" style={{ marginTop: 0 }} dividing />
    <Table basic="very" compact celled columns={3}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell textAlign="right">Actual</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">Anterior</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Caja y Bancos</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(espatrimonial.cajaBancos).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.cajaBancos).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Creditos</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(espatrimonial.creditosAC).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.creditosAC).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Bienes de Cambio</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(espatrimonial.bienesCambioAC).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.bienesCambioAC).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Total Activo Corriente</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(espatrimonial.cajaBancos, espatrimonial.creditosAC, espatrimonial.bienesCambioAC)).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(sumStringsToFloats(
                  prevEeconomico.estadoSituacionPatrimonial.cajaBancos,
                  prevEeconomico.estadoSituacionPatrimonial.creditosAC,
                  prevEeconomico.estadoSituacionPatrimonial.bienesCambioAC
                )).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
      </Table.Body>
    </Table>
    <Header as="h5" content="Activo No Corriente" style={{ marginTop: 0 }} dividing />
    <Table basic="very" compact celled columns={3}>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Creditos</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(espatrimonial.creditosANC).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.creditosANC).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Bienes de Cambio</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(espatrimonial.bienesCambioANC).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.bienesCambioANC).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Bienes de Uso</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(espatrimonial.bienesUsoANC).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.bienesUsoANC).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Total Activo No Corriente</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(espatrimonial.creditosANC, espatrimonial.bienesCambioANC, espatrimonial.bienesUsoANC)).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(sumStringsToFloats(
                  prevEeconomico.estadoSituacionPatrimonial.creditosANC,
                  prevEeconomico.estadoSituacionPatrimonial.bienesCambioANC,
                  prevEeconomico.estadoSituacionPatrimonial.bienesUsoANC
                )).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Total Activo</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(
                sumStringsToFloats(espatrimonial.cajaBancos, espatrimonial.creditosAC, espatrimonial.bienesCambioAC),
                sumStringsToFloats(espatrimonial.creditosANC, espatrimonial.bienesCambioANC, espatrimonial.bienesUsoANC)
              )).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(sumStringsToFloats(
                  sumStringsToFloats(
                    prevEeconomico.estadoSituacionPatrimonial.cajaBancos,
                    prevEeconomico.estadoSituacionPatrimonial.creditosAC,
                    prevEeconomico.estadoSituacionPatrimonial.bienesCambioAC
                  ),
                  sumStringsToFloats(
                    prevEeconomico.estadoSituacionPatrimonial.creditosANC,
                    prevEeconomico.estadoSituacionPatrimonial.bienesCambioANC,
                    prevEeconomico.estadoSituacionPatrimonial.bienesUsoANC
                  )
                )).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
      </Table.Body>
    </Table>
    <Header as="h5" content="Inversiones" dividing />
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            Concepto
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            Monto
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {
          espatrimonial.inversiones.map((inversion, index) => (
            <Table.Row key={index}>
              <Table.Cell>{inversion.concepto}</Table.Cell>
              <Table.Cell style={{ textAlign: 'right' }}>{numeral(inversion.monto).format('0,0.00')}</Table.Cell>
            </Table.Row>
          ))
        }
      </Table.Body>
    </Table>
    <Header as="h5" content="Pasivo" />
    <Header as="h5" content="Pasivo Corriente" style={{ marginTop: 0 }} dividing />
    <Table basic="very" celled columns={3}>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Deudas</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(espatrimonial.deudasPC).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.deudasPC).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
    <Header as="h5" content="Pasivo No Corriente" style={{ marginTop: 0 }} dividing />
    <Table basic="very" compact celled columns={3}>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Deudas</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(espatrimonial.deudasPNC).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoSituacionPatrimonial.deudasPNC).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Total Pasivo</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(espatrimonial.deudasPC, espatrimonial.deudasPNC)).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(sumStringsToFloats(
                  prevEeconomico.estadoSituacionPatrimonial.deudasPC,
                  prevEeconomico.estadoSituacionPatrimonial.deudasPNC
                )).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Patrimonio Neto</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(
                numeral(
                  sumStringsToFloats(
                    sumStringsToFloats(espatrimonial.cajaBancos, espatrimonial.creditosAC, espatrimonial.bienesCambioAC),
                    sumStringsToFloats(espatrimonial.creditosANC, espatrimonial.bienesCambioANC, espatrimonial.bienesUsoANC)
                  )
                ).value() - numeral(sumStringsToFloats(espatrimonial.deudasPC, espatrimonial.deudasPNC)).value()
              ).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(
                  numeral(
                    sumStringsToFloats(
                      sumStringsToFloats(
                        prevEeconomico.estadoSituacionPatrimonial.cajaBancos,
                        prevEeconomico.estadoSituacionPatrimonial.creditosAC,
                        prevEeconomico.estadoSituacionPatrimonial.bienesCambioAC
                      ),
                      sumStringsToFloats(
                        prevEeconomico.estadoSituacionPatrimonial.creditosANC,
                        prevEeconomico.estadoSituacionPatrimonial.bienesCambioANC,
                        prevEeconomico.estadoSituacionPatrimonial.bienesUsoANC
                      )
                    )
                  ).value() - numeral(sumStringsToFloats(prevEeconomico.estadoSituacionPatrimonial.deudasPC, prevEeconomico.estadoSituacionPatrimonial.deudasPNC)).value()
                ).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
      </Table.Body>
    </Table>
    <Header as="h5" content="Cursos" dividing />
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            Concepto
          </Table.HeaderCell>
          <Table.HeaderCell>
            Disertante / Asistencia
          </Table.HeaderCell>
          <Table.HeaderCell>
            Monto
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {
          espatrimonial.cursos.map((curso, index) => (
            <Table.Row key={index}>
              <Table.Cell>{curso.concepto}</Table.Cell>
              <Table.Cell>{curso.asistencia}</Table.Cell>
              <Table.Cell>{numeral(curso.monto).format('0,0.00')}</Table.Cell>
            </Table.Row>
          ))
        }
      </Table.Body>
    </Table>
  </div>
);

const EstadoEvolucionPatrimonioNeto = ({ eeconomico, prevEeconomico, data }) => {
  return (
    <div className="page-break rotate-90 margin" >
      <Header as="h4" key={3}>
        Estado de Evolucion del Patrimonio Neto
      </Header>
      <Table basic="very" compact="very">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Rubro</Table.HeaderCell>
            <Table.HeaderCell>Capital</Table.HeaderCell>
            <Table.HeaderCell>Ajuste</Table.HeaderCell>
            <Table.HeaderCell>Total</Table.HeaderCell>
            <Table.HeaderCell>Reserva Legal</Table.HeaderCell>
            <Table.HeaderCell>Reserva Esp.</Table.HeaderCell>
            <Table.HeaderCell>Resul. No Asig.</Table.HeaderCell>
            <Table.HeaderCell>{`${eeconomico ? moment(eeconomico.fechaFin).format('DD/MM/YYYY') : '---'}`}</Table.HeaderCell>
            <Table.HeaderCell>{`${eeconomico ? moment(eeconomico.fechaInicio).format('DD/MM/YYYY') : '---'}`}</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            data.map((row, index) => (
              <Table.Row key={index}>
                <Table.Cell>{row.rubro}</Table.Cell>
                <Table.Cell>{numeral(row.capitalSocial).format('0,0.00')}</Table.Cell>
                <Table.Cell>{numeral(row.ajusteCapital).format('0,0.00')}</Table.Cell>
                <Table.Cell>
                  {
                    numeral(
                      numeral(row.capitalSocial).value() +
                      numeral(row.ajusteCapital).value()
                    ).format('0,0.00')
                  }
                </Table.Cell>
                <Table.Cell>{numeral(row.reservaLegal).format('0,0.00')}</Table.Cell>
                <Table.Cell>{numeral(row.reservaEspecial).format('0,0.00')}</Table.Cell>
                <Table.Cell>{numeral(row.resultadosNoAsignados).format('0,0.00')}</Table.Cell>
                <Table.Cell>
                  {
                    numeral(
                      numeral(row.capitalSocial).value() +
                      numeral(row.ajusteCapital).value() +
                      numeral(row.reservaLegal).value() +
                      numeral(row.reservaEspecial).value() +
                      numeral(row.resultadosNoAsignados).value()
                    ).format('0,0.00')
                  }
                </Table.Cell>
                <Table.Cell>
                  {
                    prevEeconomico ?
                      numeral(
                        numeral(prevEeconomico.estadoEvolucionPatrimonio.matrix[index].capitalSocial).value() +
                        numeral(prevEeconomico.estadoEvolucionPatrimonio.matrix[index].ajusteCapital).value() +
                        numeral(prevEeconomico.estadoEvolucionPatrimonio.matrix[index].reservaLegal).value() +
                        numeral(prevEeconomico.estadoEvolucionPatrimonio.matrix[index].reservaEspecial).value() +
                        numeral(prevEeconomico.estadoEvolucionPatrimonio.matrix[index].resultadosNoAsignados).value()
                      ).format('0,0.00') : '---'
                  }
                </Table.Cell>
              </Table.Row>
            ))
          }
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell>
              Total
            </Table.HeaderCell>
            <Table.HeaderCell>
              {
                numeral(data.reduce((prev, curr) => prev + numeral(curr.capitalSocial).value(), 0)).format('0,0.00')
              }
            </Table.HeaderCell>
            <Table.HeaderCell>
              {
                numeral(data.reduce((prev, curr) => prev + numeral(curr.ajusteCapital).value(), 0)).format('0,0.00')
              }
            </Table.HeaderCell>
            <Table.HeaderCell>
              {
                numeral(
                  (data.reduce((prev, curr) => prev + numeral(curr.capitalSocial).value(), 0)) +
                  (data.reduce((prev, curr) => prev + numeral(curr.ajusteCapital).value(), 0))
                ).format('0,0.00')
              }
            </Table.HeaderCell>
            <Table.HeaderCell>
              {
                numeral(data.reduce((prev, curr) => prev + numeral(curr.reservaLegal).value(), 0)).format('0,0.00')
              }
            </Table.HeaderCell>
            <Table.HeaderCell>
              {
                numeral(data.reduce((prev, curr) => prev + numeral(curr.reservaEspecial).value(), 0)).format('0,0.00')
              }
            </Table.HeaderCell>
            <Table.HeaderCell>
              {
                numeral(data.reduce((prev, curr) => prev + numeral(curr.resultadosNoAsignados).value(), 0)).format('0,0.00')
              }
            </Table.HeaderCell>
            <Table.HeaderCell>
              {
                numeral(
                  (data.reduce((prev, curr) => prev + numeral(curr.capitalSocial).value(), 0)) +
                  (data.reduce((prev, curr) => prev + numeral(curr.ajusteCapital).value(), 0)) +
                  (data.reduce((prev, curr) => prev + numeral(curr.reservaLegal).value(), 0)) +
                  (data.reduce((prev, curr) => prev + numeral(curr.reservaEspecial).value(), 0)) +
                  (data.reduce((prev, curr) => prev + numeral(curr.resultadosNoAsignados).value(), 0))
                ).format('0,0.00')
              }
            </Table.HeaderCell>
            <Table.HeaderCell>
              {
                prevEeconomico ?
                  numeral(
                    (prevEeconomico.estadoEvolucionPatrimonio.matrix.reduce((prev, curr) => prev + numeral(curr.capitalSocial).value(), 0)) +
                    (prevEeconomico.estadoEvolucionPatrimonio.matrix.reduce((prev, curr) => prev + numeral(curr.ajusteCapital).value(), 0)) +
                    (prevEeconomico.estadoEvolucionPatrimonio.matrix.reduce((prev, curr) => prev + numeral(curr.reservaLegal).value(), 0)) +
                    (prevEeconomico.estadoEvolucionPatrimonio.matrix.reduce((prev, curr) => prev + numeral(curr.reservaEspecial).value(), 0)) +
                    (prevEeconomico.estadoEvolucionPatrimonio.matrix.reduce((prev, curr) => prev + numeral(curr.resultadosNoAsignados).value(), 0))
                  ).format('0,0.00') : '---'
              }
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </div>
  );
};

const EstadoResultados = ({ eeconomico, prevEeconomico, estadoResultados }) => (
  <div>
    <Table basic="very" celled compact columns={3}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell textAlign="right">Actual</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">Anterior</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Ingresos por Ventas</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.ingresosVentas).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.ingresosVentas).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Costo de Ventas (anexo II)</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.costoVentas).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.costoVentas).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>
            Excedente Bruto
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(
                estadoResultados.ingresosVentas,
                estadoResultados.costoVentas
              )).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(sumStringsToFloats(
                  prevEeconomico.estadoResultados.ingresosVentas,
                  prevEeconomico.estadoResultados.costoVentas
                )).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Egresos Comercializacion (Anexo III)</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.egresosComercializacion).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.egresosComercializacion).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Egresos Administracion (Anexo III)</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.egresosAdministracion).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.egresosAdministracion).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Egresos Financieros (Anexo III)</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.egresosFinancieros).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.egresosFinancieros).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Egresos Fiscales (Anexo III)</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.egresosFiscales).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.egresosFiscales).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Egresos Generales (Anexo III)</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.egresosGenerales).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.egresosGenerales).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>
            Excedente Operativo
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(
                estadoResultados.ingresosVentas,
                estadoResultados.costoVentas,
                estadoResultados.egresosComercializacion,
                estadoResultados.egresosAdministracion,
                estadoResultados.egresosFinancieros,
                estadoResultados.egresosFiscales,
                estadoResultados.egresosGenerales
              )).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(sumStringsToFloats(
                  prevEeconomico.estadoResultados.ingresosVentas,
                  prevEeconomico.estadoResultados.costoVentas,
                  prevEeconomico.estadoResultados.egresosComercializacion,
                  prevEeconomico.estadoResultados.egresosAdministracion,
                  prevEeconomico.estadoResultados.egresosFinancieros,
                  prevEeconomico.estadoResultados.egresosFiscales,
                  prevEeconomico.estadoResultados.egresosGenerales
                )).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Ingresos Indirectamente atribuidos</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.ingresosIndirectamenteAtribuidos).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.ingresosIndirectamenteAtribuidos).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Gastos Indirectamente atribuidos</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.gastosIndirectamenteAtribuidos).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.gastosIndirectamenteAtribuidos).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Ingresos Extraordinarios</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.ingresosExtraordinarios).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.ingresosExtraordinarios).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>
            Excedente neto del ejercicio
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(
                estadoResultados.ingresosVentas,
                estadoResultados.costoVentas,
                estadoResultados.egresosComercializacion,
                estadoResultados.egresosAdministracion,
                estadoResultados.egresosFinancieros,
                estadoResultados.egresosFiscales,
                estadoResultados.egresosGenerales,
                estadoResultados.ingresosIndirectamenteAtribuidos,
                estadoResultados.gastosIndirectamenteAtribuidos,
                estadoResultados.ingresosExtraordinarios
              )).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(sumStringsToFloats(
                  prevEeconomico.estadoResultados.ingresosVentas,
                  prevEeconomico.estadoResultados.costoVentas,
                  prevEeconomico.estadoResultados.egresosComercializacion,
                  prevEeconomico.estadoResultados.egresosAdministracion,
                  prevEeconomico.estadoResultados.egresosFinancieros,
                  prevEeconomico.estadoResultados.egresosFiscales,
                  prevEeconomico.estadoResultados.egresosGenerales,
                  prevEeconomico.estadoResultados.ingresosIndirectamenteAtribuidos,
                  prevEeconomico.estadoResultados.gastosIndirectamenteAtribuidos,
                  prevEeconomico.estadoResultados.ingresosExtraordinarios
                )).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Resultado por la gestion cooperativa con Asociados</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.resultadoGestionAsociados).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.resultadoGestionAsociados).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Resultado por la gestion cooperativa con No Asociados</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.resultadoGestionNoAsociados).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.resultadoGestionNoAsociados).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Resultado por operaciones ajenas a la gestion cooperativa</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(estadoResultados.resultadoOperacionesAjenas).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.estadoResultados.resultadoOperacionesAjenas).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>
            Excedente Neto del ejercicio
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(
                estadoResultados.resultadoGestionAsociados,
                estadoResultados.resultadoGestionNoAsociados,
                estadoResultados.resultadoOperacionesAjenas
              )).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(sumStringsToFloats(
                  prevEeconomico.estadoResultados.resultadoGestionAsociados,
                  prevEeconomico.estadoResultados.resultadoGestionNoAsociados,
                  prevEeconomico.estadoResultados.resultadoOperacionesAjenas
                )).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
      </Table.Body>
    </Table>
    <Header as="h5" content="Volumenes de Venta" dividing />
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            Concepto
          </Table.HeaderCell>
          <Table.HeaderCell>
            Unidad
          </Table.HeaderCell>
          <Table.HeaderCell>
            M. Interno
          </Table.HeaderCell>
          <Table.HeaderCell>
            M. Externo
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {
          estadoResultados.volumenesVenta.map((volumenVenta, index) => (
            <Table.Row key={index}>
              <Table.Cell>{volumenVenta.concepto}</Table.Cell>
              <Table.Cell>{volumenVenta.unidad}</Table.Cell>
              <Table.Cell>{numeral(volumenVenta.minterno).format('0,0.00')}</Table.Cell>
              <Table.Cell>{numeral(volumenVenta.mexterno).format('0,0.00')}</Table.Cell>
            </Table.Row>
          ))
        }
      </Table.Body>
    </Table>
    <Header as="h5" content="Personal" dividing />
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            Concepto
          </Table.HeaderCell>
          <Table.HeaderCell>
            Unidad
          </Table.HeaderCell>
          <Table.HeaderCell>
            Cantidad
          </Table.HeaderCell>
          <Table.HeaderCell>
            Tiempo
          </Table.HeaderCell>
          <Table.HeaderCell>
            Remuneracion
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {
          estadoResultados.personal.map((personal, index) => (
            <Table.Row key={index}>
              <Table.Cell>{personal.concepto}</Table.Cell>
              <Table.Cell>{personal.unidad}</Table.Cell>
              <Table.Cell>{personal.cantidad}</Table.Cell>
              <Table.Cell>{personal.tiempo}</Table.Cell>
              <Table.Cell>{numeral(personal.remuneracion).format('0,0.00')}</Table.Cell>
            </Table.Row>
          ))
        }
      </Table.Body>
    </Table>
  </div>
);

const PropuestaAplicacionDistribucionExcedentes = ({ prevEeconomico, eeconomico, propuestaAplicacionDistribucion }) => (
  <div>
    <Table basic="very" compact celled columns={3}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell textAlign="right">Actual</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">Anterior</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Excedentes del Ejercicio</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(propuestaAplicacionDistribucion.excedenteEjercicio).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.excedenteEjercicio).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Resultado por la gestion cooperativa con No Asociados</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(propuestaAplicacionDistribucion.resultadoGestionNoAsociados).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.resultadoGestionNoAsociados).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Resultado por operaciones ajenas a la gestion cooperativa</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(propuestaAplicacionDistribucion.resultadoOperacionesAjenas).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.resultadoOperacionesAjenas).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Resultado Neto por la gestion cooperativa con Asociados</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(
                propuestaAplicacionDistribucion.excedenteEjercicio,
                propuestaAplicacionDistribucion.resultadoGestionNoAsociados,
                propuestaAplicacionDistribucion.resultadoOperacionesAjenas
              )).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(sumStringsToFloats(
                  prevEeconomico.propuestaAplicacionDistribucion.excedenteEjercicio,
                  prevEeconomico.propuestaAplicacionDistribucion.resultadoGestionNoAsociados,
                  prevEeconomico.propuestaAplicacionDistribucion.resultadoOperacionesAjenas
                )).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Reserva Legal</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(propuestaAplicacionDistribucion.reservaLegal).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.reservaLegal).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Reserva Art 42</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(propuestaAplicacionDistribucion.reservaArt42).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.reservaArt42).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Fondo para Estimulo del Personal</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(propuestaAplicacionDistribucion.fondoEstimulo).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.fondoEstimulo).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Fondo para Educacion y Capacitacion Cooperativa</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(propuestaAplicacionDistribucion.fondoEducacionCapacitacion).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.fondoEducacionCapacitacion).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell>Excedentes repartibles</Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              numeral(sumStringsToFloats(
                propuestaAplicacionDistribucion.excedenteEjercicio,
                propuestaAplicacionDistribucion.resultadoGestionNoAsociados,
                propuestaAplicacionDistribucion.resultadoOperacionesAjenas,
                propuestaAplicacionDistribucion.reservaLegal,
                propuestaAplicacionDistribucion.reservaArt42,
                propuestaAplicacionDistribucion.fondoEstimulo,
                propuestaAplicacionDistribucion.fondoEducacionCapacitacion
              )).format('0,0.00')
            }
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="right">
            {
              prevEeconomico ?
                numeral(sumStringsToFloats(
                  prevEeconomico.propuestaAplicacionDistribucion.excedenteEjercicio,
                  prevEeconomico.propuestaAplicacionDistribucion.resultadoGestionNoAsociados,
                  prevEeconomico.propuestaAplicacionDistribucion.resultadoOperacionesAjenas,
                  prevEeconomico.propuestaAplicacionDistribucion.reservaLegal,
                  prevEeconomico.propuestaAplicacionDistribucion.reservaArt42,
                  prevEeconomico.propuestaAplicacionDistribucion.fondoEstimulo,
                  prevEeconomico.propuestaAplicacionDistribucion.fondoEducacionCapacitacion
                )).format('0,0.00') : '---'
            }
          </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Intereses a pagar en efectivo</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(propuestaAplicacionDistribucion.interesesAPagar).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.interesesAPagar).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Excedentes en cuotas sociales</Table.Cell>
          <Table.Cell textAlign="right">
            {numeral(propuestaAplicacionDistribucion.excedentesCuotaSocial).format('0,0.00')}
          </Table.Cell>
          <Table.Cell textAlign="right">
            {
              prevEeconomico ? numeral(prevEeconomico.propuestaAplicacionDistribucion.excedentesCuotaSocial).format('0,0.00') : '---'
            }
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  </div>
);

function totalizeAportes (row) {
  return (
    numeral(row.capitalSocial).value() +
    numeral(row.ajusteCapital).value()
  ).toFixed(2);
}

function totalizeRow (row) {
  return (
    numeral(row.capitalSocial).value() +
    numeral(row.ajusteCapital).value() +
    numeral(row.reservaLegal).value() +
    numeral(row.reservaEspecial).value() +
    numeral(row.resultadosNoAsignados).value()
  ).toFixed(2);
}

export default feathersConnect(
  connect(
    ReportePorMatriculaView.mapStateToProps,
    ReportePorMatriculaView.mapDispatchToProps
  )(ReportePorMatriculaView)
);



// WEBPACK FOOTER //
// ./client/components/pages/informes/ReportePorMatriculaView.js